const TOKEN_IN_PATH = /(\/i\/|\/notifications\/landing\/)[^/?#\s"']+/g;
const TOKEN_MARK = '[token]';

export const scrubLandingTokens = (text: string): string => text.replace(TOKEN_IN_PATH, `$1${TOKEN_MARK}`);

export const scrubbedUrl = (url: string | undefined): string | undefined => (url === undefined ? undefined : scrubLandingTokens(url));
